import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "app-composite-filter",
    template: `
        <div class="row">
          <div class="col-4">
            <select [(ngModel)]="filter.field" (change)="onChangeField($event.target.value)" placeholder="select field"
              class="form-control mx-1"
              [name]="'filter'">
              @for (value of fields; track value) {
                <option
                  value={{value.name}}>
                  {{ value.name }}
                </option>
              }
            </select>
          </div>
        
          @if (operators) {
            <div class="col-4">
              <select [(ngModel)]="filter.operator" placeholder="select operator" (change)="updateOutput()"
                class="form-control mx-1"
                [name]="'operator'">
                @for (value of operators; track value) {
                  <option [value]="value.key">
                    {{ value.name }}
                  </option>
                }
              </select>
            </div>
          }
          @if (!['$isNull', '$isNotNull'].includes(filter.operator)) {
            <div class="col-3">
              @if (filter.type == 'text') {
                <input type="text" class="form-control mx-1" [(ngModel)]="filter.value" placeholder="enter value" (keyup)="updateOutput()">
              }
              @if (filter.type == 'number') {
                <input type="number" class="form-control mx-1" [(ngModel)]="filter.value" placeholder="enter value" (keyup)="updateOutput()"
                  >
              }
              @if (filter.type == 'date') {
                <input type="date" class="form-control mx-1" [(ngModel)]="filter.value" placeholder="enter value" (change)="updateOutput()">
              }
            </div>
          }
        </div>
        `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CompositeFilterComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CompositeFilterComponent implements ControlValueAccessor, OnChanges{

    ngOnChanges(changes: SimpleChanges): void {
        setTimeout(()=> {
            if (!this.filter.type) this.filter.type = 'text';
            this.operators = this.allOperators[this.filter.type];
        }, 50)

    }

    writeValue(obj: any): void {
        if (obj){
            this.filter = obj;
        }
    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn
    }
    registerOnTouched(fn: any): void {
    }
    setDisabledState?(isDisabled: boolean): void {
    }

    propagateChange = (_: any) => {};

    @Input()
    fields
    allOperators = {
        'text': [{name: 'Is equal to', key: '$eq'},
            {name: 'Is not equal to', key: '$ne'},
            {name: 'Contains', key: '$contains'},
            {name: 'Is empty', key: '$isNull'},
            {name: 'Is not empty', key: '$isNotNull'},
        ]
        ,

        'number': [{name: 'Is equal to', key: '$eq'},
            {name: 'Is not equal to', key: '$ne'},
            {name: 'Is greater than or equal to', key: '$gte'},
            {name: 'Is greater than', key: '$gt'},
            {name: 'Is less than or equal to', key: '$lte'},
            {name: 'Is less than', key: '$lt'},
            {name: 'Is empty', key: '$isNull'},
            {name: 'Is not empty', key: '$isNotNull'},
        ]
        ,

        'date': [{name: 'Is after or equal to', key: '$gte'},
            {name: 'Is after', key: '$gt'},
            {name: 'Is before or equal to', key: '$lte'},
            {name: 'Is before', key: '$lt'},
            {name: 'Is empty', key: '$isNull'},
            {name: 'Is not empty', key: '$isNotNull'},
        ]
    };

    // @Input()
    filter = {field: '', operator: '', value: '', type: ''};
    operators = null;

    @Output() output: EventEmitter<any> = new EventEmitter();

    onChangeField(value: any) {
        const type = this.fields.find(item => item.name == value)?.type;
        let newType = 'text'
        if (["3"].includes(type)) {
            newType = 'number';
        } else if (["4"].includes(type)) {
            newType = 'date';
        }
        if (newType != this.filter.type) {
            this.filter.value = ''
            this.filter.operator = ''
        }
        this.filter.type = newType;
        this.operators = this.allOperators[newType];
        this.propagateChange(this.filter)
    }

    updateOutput() {
        // this.output.emit(this.filter);
        this.propagateChange(this.filter)
    }
}